import { createSlice } from "@reduxjs/toolkit";

const getAdminFee = createSlice({
  name: "getAdminFee",
  initialState: {
    data: {},
  },

  reducers: {
    getAdminFees(state, action) {
      state.data = action.payload;
      state.loading = false;
    },
  },
});

export const { getAdminFees } = getAdminFee.actions;
export default getAdminFee.reducer;
